import React, { useState, useEffect, useRef } from "react";
import logo_bluesky_landing from "../../assets/images/logo_bluesky_landing.svg";
import call3 from "../../assets/images/call3.svg";
import { MdChevronRight } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import { Link } from "react-router-dom";
import { FaAngleDown } from "react-icons/fa6";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownOpen1, setIsDropdownOpen1] = useState(false);
  const [activeLink, setActiveLink] = useState("");
  const dropdownRef = useRef(null);

  const handleLinkClick = (link) => {
    setActiveLink(link);
    setIsOpen(false);
    setIsDropdownOpen(false);
    setIsDropdownOpen1(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const toggleDropdown = (dropdown) => {
    if (dropdown === "about") {
      setIsDropdownOpen((prev) => !prev);
      setIsDropdownOpen1(false);
    } else if (dropdown === "news") {
      setIsDropdownOpen1((prev) => !prev);
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
        setIsDropdownOpen1(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="bg-white w-full px-4 lg:px-6 py-2.5">
      <div className="flex flex-wrap md:flex-nowrap justify-between lg:justify-around lg:flex lg:items-center md:w-full md:flex-row items-center w-full">
        <a className="flex items-center">
          <Link to="/" onClick={() => handleLinkClick("home")}>
            <img
              src={logo_bluesky_landing}
              className="mr-3 lg:w-[190px] lg:h-[55px] w-[170px] h-[48.8px] cursor-pointer"
              alt="Flowbite React Logo"
            />
          </Link>
        </a>
        <div className="flex items-center md:order-2">
          <button
            type="button"
            className="text-white hidden lg:block md:hidden font-medium bg-blue-sky-gradient1 rounded-lg text-sm px-4 py-2 text-center mr-3 md:mr-0 lg:w-56 lg:rounded-[30px] h-11"
          >
            <div className="w-full flex items-center justify-center gap-3">
              <img src={call3} alt="call3" />
              <p className="whitespace-nowrap">Hotline : 096 859 68 59</p>
            </div>
          </button>
          <button
            onClick={() => setIsOpen(!isOpen)}
            type="button"
            className="inline-flex items-center p-2 ml-1 text-sm text-gray-500 rounded-lg md:hidden lg:hidden"
            aria-controls="mobile-menu"
            aria-expanded={isOpen ? "true" : "false"}
          >
            <span className="sr-only">Open main menu</span>
            {isOpen ? (
              <IoMdClose className="w-[36px] h-[36px]" />
            ) : (
              <svg
                className="w-[36px] h-[36px]"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M3 5h14a1 1 0 010 2H3a1 1 0 110-2zm0 4h14a1 1 0 010 2H3a1 1 0 110-2zm0 4h14a1 1 0 010 2H3a1 1 0 110-2z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </button>
        </div>
        <div
          className={`w-full md:flex md:w-auto ${isOpen ? "block" : "hidden"}`}
          id="mobile-menu"
        >
          <ul
            className="flex md:flex lg:block lg:flex flex-col m-0 p-0 mt-4 list-none md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium"
            ref={dropdownRef}
          >
            <li className="flex items-center justify-between w-full">
              <Link
                to="/"
                className={`block py-2 pr-4 pl-3 text-[1rem] font-normal rounded md:p-0 whitespace-nowrap ${
                  activeLink === "home"
                    ? "border-b-2 border-[#27C6FF] text-[#27C6FF]"
                    : "text-black"
                }`}
                aria-current="page"
                onClick={() => handleLinkClick("home")}
              >
                Trang chủ
              </Link>
              <MdChevronRight size={30} className="block lg:hidden md:hidden" />
            </li>
            <li className="relative">
              <button
                onClick={() => toggleDropdown("about")}
                className="flex items-center justify-between w-full lg:gap-2 py-2 px-3 whitespace-nowrap text-[1rem] font-normal rounded"
              >
                Về chúng tôi
                <FaAngleDown size={20} className="text-[#27C6FF]" />
              </button>
              {isDropdownOpen && (
                <div className="lg:absolute lg:left-0 mt-2 lg:w-60 w-full bg-white md:absolute md:w-[15rem] md:rounded-md md:bg-white md:shadow-md pl-5 lg:pl-0 lg:rounded-lg lg:shadow-lg lg:z-10">
                  <ul className="py-2 text-sm p-0 m-0">
                    <li className="flex items-center gap-3 lg:pl-2 hover:text-[#27C6FF]">
                      <MdChevronRight
                        size={30}
                        className="hover:text-[#27C6FF]"
                      />
                      <Link
                        to="/aboutus"
                        className={`block px-4 py-2 text-[1rem] md:whitespace-nowrap lg:hover:text-[#27C6FF] font-normal ${
                          activeLink === "aboutus"
                            ? "border-b-2 border-blue-500 text-blue-500"
                            : "text-black"
                        }`}
                        onClick={() => handleLinkClick("aboutus")}
                      >
                        Về chúng tôi
                      </Link>
                    </li>
                    <li className="flex items-center gap-3 lg:pl-2 hover:text-[#27C6FF]">
                      <MdChevronRight
                        size={30}
                        className="hover:text-[#27C6FF]"
                      />
                      <Link
                        to="member-team"
                        className={`block px-4 py-2 text-[1rem] font-normal md:whitespace-nowrap lg:hover:text-[#27C6FF] ${
                          activeLink === "member-team" ? "" : "text-black"
                        }`}
                        onClick={() => handleLinkClick("member-team")}
                      >
                        Đội ngũ thành viên
                      </Link>
                    </li>
                    <li className="flex items-center gap-3 lg:pl-2 hover:text-[#27C6FF]">
                      <MdChevronRight
                        size={30}
                        className="hover:text-[#27C6FF]"
                      />
                      <Link
                        to="bussiness-part"
                        className={`block px-4 py-2 text-[1rem] font-normal md:whitespace-nowrap lg:hover:text-[#27C6FF] ${
                          activeLink === "member-team" ? "" : "text-black"
                        }`}
                        onClick={() => handleLinkClick("bussiness-part")}
                      >
                        Đối tác
                      </Link>
                    </li>
                    <li className="flex items-center gap-3 lg:pl-2 hover:text-[#27C6FF]">
                      <MdChevronRight
                        size={30}
                        className="hover:text-[#27C6FF]"
                      />
                      <Link
                        to="recruitment"
                        className={`block px-4 py-2 text-[1rem] font-normal md:whitespace-nowrap lg:hover:text-[#27C6FF] ${
                          activeLink === "member-team" ? "" : "text-black"
                        }`}
                        onClick={() => handleLinkClick("recruitment")}
                      >
                        Tuyển dụng
                      </Link>
                    </li>
                    <li className="flex items-center gap-3 lg:pl-2 hover:text-[#27C6FF]">
                      <MdChevronRight
                        size={30}
                        className="hover:text-[#27C6FF]"
                      />
                      <Link
                        to="library"
                        className={`block px-4 py-2 text-[1rem] font-normal md:whitespace-nowrap lg:hover:text-[#27C6FF] ${
                          activeLink === "library" ? "" : "text-black"
                        }`}
                        onClick={() => handleLinkClick("library")}
                      >
                        Thư viện ảnh
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>
            <li className="flex items-center justify-between w-full">
              <Link
                to="produ"
                className={`block py-2 pr-4 pl-3 text-[1rem] font-normal rounded md:p-0 whitespace-nowrap ${
                  activeLink === "produ"
                    ? "border-b-2 border-[#27C6FF] text-[#27C6FF]"
                    : "text-black"
                }`}
                onClick={() => handleLinkClick("produ")}
              >
                Sản phẩm
              </Link>
              <MdChevronRight size={30} className="block lg:hidden md:hidden" />
            </li>
            <li className="flex items-center justify-between w-full">
              <Link
                to="time-new"
                className={`block py-2 pr-4 pl-3 text-[1rem] font-normal rounded md:p-0 whitespace-nowrap ${
                  activeLink === "time-new"
                    ? "border-b-2 border-[#27C6FF] text-[#27C6FF]"
                    : "text-black"
                }`}
                onClick={() => handleLinkClick("time-new")}
              >
                Tin tức
              </Link>
              <MdChevronRight size={30} className="block lg:hidden md:hidden" />
            </li>
            <li className="flex items-center justify-between w-full">
              <Link
                to="contact-us"
                className={`block py-2 pr-4 pl-3 text-[1rem] font-normal rounded md:p-0 whitespace-nowrap ${
                  activeLink === "contact-us"
                    ? "border-b-2 border-[#27C6FF] text-[#27C6FF]"
                    : "text-black"
                }`}
                onClick={() => handleLinkClick("contact-us")}
              >
                Liên hệ
              </Link>
              <MdChevronRight size={30} className="block lg:hidden md:hidden" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
